module.exports = __webpack_public_path__ + "img/undraw_events.fa506fda.svg";